import React from 'react'
import HeroSlider from "../components/UI/HeroSlider"
import Helmet from '../components/Helmet/Helmet'
import { Container, Row, Col } from "reactstrap";

import AboutSection from "../components/UI/AboutSection";
import ServicesList from "../components/UI/ServicesList";
import carData from "../assets/data/carData";
import CarItem from "../components/UI/CarItem";
import BecomeDriverSection from "../components/UI/BecomeDriverSection";
import Testimonial from "../components/UI/Testimonial";
import BlogList from "../components/UI/BlogList";


const Home = () => {
  return (
    <Helmet>
       {/* ============= hero section =========== */}
       <section className="p-0 hero__slider-section">
        <HeroSlider />    
        </section>
        <Container>
          <Row>
            <Col lg="12" className="mb-3 pt-5">
              <h6 className="section_subtitle"></h6>
              <h6 className="section_subtitle">Trusted By:</h6>
            </Col>
            <Testimonial />
          </Row>
        </Container>
        


        {/* =========== about section ================ */}
      <AboutSection />
       {/* ========== services section ============ */}
       <section>
        {/* <Container>
          <Row>
            <Col lg="12" className="mb-5 text-center">
              <h6 className="section__subtitle1">See our</h6>
              <h2 className="section__title1">Our Services</h2>
            </Col>

            <ServicesList />
          </Row>
        </Container> */}
      </section>
       {/* =========== car offer section ============= */}
       <section>
        <Container>
          <Row>
            <Col lg="12" className="text-center mb-5">
              <h1 className="section__title">Our Services</h1>
              <h6 className="section_description text-center">We Provide the Better Services For Our Customers</h6>
            </Col>

            {carData.slice(0, 6).map((item) => (
              <CarItem item={item} key={item.id} />
            ))}
          </Row>
        </Container>
      
        {/* <Container>
          <Row>
            <Col lg="12" className="mb-4 text-center">
              <h6 className="section_subtitle"></h6>
              <h2 className="section__title1">Our Clients</h2>
            </Col>

            <Testimonial />
          </Row>
        </Container> */}
      </section>
       {/* =============== blog section =========== */}
       <section>
        {/* <Container>
          <Row>
            <Col lg="12" className="mb-5 text-center">
              <h6 className="section__subtitle">Explore our blogs</h6>
              <h2 className="section__title1">Explore our blogs</h2>
            </Col>

            <BlogList />
          </Row>
        </Container> */}
      </section>


    </Helmet>

  )
}

export default Home
